import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '../../../externals/routing';

const AppHeaderLeftContainer = () => (
  <div className="header-left-container">
    <Link to="/">
      <div className="app-title">
        <FormattedMessage id="app.title" tagName="h1" />
      </div>
    </Link>
  </div>
);

export default AppHeaderLeftContainer;
